import styled from 'styled-components';

export const Panel = styled.div`
  background: ${props => props.theme.colors.white};
  border-radius: ${props => props.theme.borderRadius};
  box-shadow: ${props => props.theme.boxShadow};

  &.u-inner {
    max-width: 100%;
    margin: 0 auto;
  }
`;

export const Content = styled.div`
  padding: 2rem 1rem;

  @media ${props => props.theme.breakpoints.lg} {
    padding: 1rem 0rem;
  }
`;

export default Panel;
